import { CommonModule } from "@angular/common";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { IonicModule, ToastController } from "@ionic/angular";
import { Component, forwardRef, Inject } from "@angular/core";
import { ActivatedRoute, Router, RouterEvent } from "@angular/router";
import {
	MenuController,
	ModalController,
	NavController,
	Platform,
} from "@ionic/angular";
import { filter } from "rxjs/operators";
import { SwUpdate } from "@angular/service-worker";
interface MenuItems {
	displayName: string;
	page: string;
	icon: string;
}
@Component({
	selector: "app-root",
	templateUrl: "app.component.html",
	styleUrls: ["app.component.scss"],
	standalone: true,
	imports: [
		IonicModule,
		RouterLink,
		RouterLinkActive,
		CommonModule,
	],
})
export class AppComponent {
	menuItems: Array<MenuItems> = [];
	public selectedItem: string;
	public dark: boolean;
	public ownersExpanded: boolean = false;
	public ridersExpanded: boolean = false;
	constructor(
		public platform: Platform,
		public navCtrl: NavController,
		public route: ActivatedRoute,
		public modalCtrl: ModalController,
		public router: Router,
		public menu: MenuController,
		private swUpdate: SwUpdate,
		private toastCtrl: ToastController,
	) {
		this.initializeApp();
		this.selectedItem = "home";
		this.dark = true;
	}

	initializeApp() {
		let refreshing;
		let that = this;
		// this.windowService.determineWindowSize();

		this.platform.ready().then(() => {
			let deferredPrompt;


			window.addEventListener("unhandledrejection", function (event) {
				console.warn(
					"WARNING: Unhandled promise rejection. Shame on you! Reason: " +
						event.reason
				);
				// that.errorService.handleError(event.reason);
			});

			document.documentElement.addEventListener(
				"gesturestart",
				function (event) {
					console.log("PREVENTING ZOOM");
					event.preventDefault();
				},
				false
			);

			this.router.events
				.pipe(filter((e) => e instanceof RouterEvent))
				.subscribe((e) => {
					let event = e as RouterEvent;
					let end =
						event.url.indexOf(";") == -1
							? event.url.length
							: event.url.indexOf(";");
					let pageStr = event.url.substring(event.url.indexOf("/") + 1, end);
					if (pageStr) {
						this.selectedItem = pageStr;
					}
				});
		});

	}

	toggleSubMenu(): void {
		this.ownersExpanded = !this.ownersExpanded;
	}

	toggleRiderSubMenu(): void {
		this.ridersExpanded = !this.ridersExpanded;
	}
}
